import {
  PasswordField,
  TextField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import FormControls from '@elementary/common-ui/components/FormControls';
import { UseFormReturn } from 'react-hook-form';
import { TableauForm as TableauFormFields } from 'shared/types';

const TableauForm = ({
  formMethods,
}: {
  formMethods: UseFormReturn<TableauFormFields, any, undefined>;
}) => {
  const {
    register,
    formState: { errors, dirtyFields },
    setValue,
  } = formMethods;

  return (
    <>
      <FormControls.InputWrapper>
        <TextField
          {...register('tableauConnectionName', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Connection name"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.tableauConnectionName?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControls.InputWrapper>
        <TextField
          {...register('tableauPersonalAccessTokenName', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Personal access token name"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.tableauPersonalAccessTokenName?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControls.InputWrapper>
        <PasswordField
          {...register('tableauPersonalAccessTokenValue', {
            required: requiredLabel,
          })}
          label="Personal access token value"
          isFormValueDirty={dirtyFields.tableauPersonalAccessTokenValue}
          clearFormValue={() => setValue('tableauPersonalAccessTokenValue', '')}
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.tableauPersonalAccessTokenValue?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControls.InputWrapper>
        <TextField
          {...register('tableauServerUrl', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Site URL"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.tableauServerUrl?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>
      <FormControls.InputWrapper>
        <TextField
          {...register('tableauSiteName')}
          variant="outlined"
          label="Site name"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.tableauSiteName?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>
    </>
  );
};

export default TableauForm;
